import { Button } from "shared/components/Button";
import { MaxWidth } from "shared/components/MaxWidth";
import styles from "./CtaSection.module.css";

export const CtaSection = ({ title, button }) => {
  if (!title && !button?.label) return null;

  return (
    <div className={styles.container}>
      <MaxWidth>
        {title && <h2 className={styles.title}>{title}</h2>}
        {button?.label && <Button {...button}>{button?.label}</Button>}
      </MaxWidth>
    </div>
  );
};
